module.exports = __webpack_public_path__ + "static/Creator 17 - @LusorKoeffizient-a73c6da339b9cba92c62f5dd10ca0d47.png";